<template>
    <div class="search-result__tile global-material-tile">
        <a class="tile--link" :href="result.href" @click="openLink">
            <img class="tile--image img-responsive" :title="result.title" :src="result.image_src" :alt="result.alt" @load="onImageLoaded">
            <p class="tile--title"><b>{{ result.title }}</b>&nbsp;{{ result.titleSuffix }}</p>
            <p class="tile--subtitle">{{ result.subtitle }}</p>
        </a>
    </div>
</template>

<script>
	import constants from "@search/shared/constants";

	export default {
        name: "search-result-tile",
        props: {
            result: {
                type: Object,
                default: function () {
                    return {
                        alt: "Product",
                        src: "https://via.placeholder.com/200x200?text=PRODUCT",
                        href: "#",
                        title: "TitleBold",
                        titleSuffix: "Title regular",
                        subtitle: "Subtitle",
                    }
                }
            }
        },
		methods: {
			openLink() {
				const scrollOffset = Math.floor(window.pageYOffset); // Damit da kein 2160.23452534532 rauskommt....

				if (this.$store.state.category !== constants.resultKind.all) {
					const activeCat = this.$store.getters.searchResultsForKind(this.$store.state.category);

					// Offset muss hier reduziert werden, da results.length schon das Offset für eine Seite mehr wäre
					const offset = Math.max(activeCat.results.length - constants.resultsPerPage, 0);

					// for history back
					const scrolledUrl = window.location.pathname+'?tx_salbase9_search[q]=' + this.$store.state.keyword + '&tx_salbase9_search[cat]=' + this.$store.state.category + '#' + offset + ',' + scrollOffset;
					// console.log('replacing history with', scrolledUrl);
					history.replaceState({}, '', scrolledUrl);
				}
				else {
					// for history back
					const scrolledUrl = window.location.pathname+'?tx_salbase9_search[q]=' + this.$store.state.keyword + '#0,'+scrollOffset;
					// console.log('replacing history with', scrolledUrl);
					history.replaceState({}, '', scrolledUrl);
				}
			},
			onImageLoaded() {
				// console.log('Image loaded');
				this.$emit('image-loaded');
			}
		}
    }
</script>
